import { createFileRoute } from '@tanstack/react-router'
import { PanelPage } from '@/features/panel';

export const Route = createFileRoute('/_authenticated/ticketing/panel/')({
    component: PanelPage,
});
